import axios from "axios";
import { STATUSES } from "./apiStatus";
import { apiEndpoint } from "../../../urls"
import { toast } from "react-toastify";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const getTemplatesApi = createAsyncThunk(
  "getTemplate/fetch",
  async (data, { rejectWithValue, serializeError, dispatch }) => {
    try {
      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/get_template/${data.document_id}/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${data.token}`,
          },
        }
      );
      if (!response.data.status) {
        toast.error(response.data.message);
      }
      return response.data;
    } catch (error) {
      toast.error(error.message);
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const getTemplateSlice = createSlice({
  name: "getTemplate",
  initialState: {
    templateData: null,
    templateStatus: "idle",
  },
  reducers: {
    setShowAlert: (state, action) => {
      state.showAlert = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTemplatesApi.pending, (state, action) => {
        state.documentStatus = STATUSES.LOADING;
      })
      .addCase(getTemplatesApi.fulfilled, (state, action) => {
        state.templateData = action.payload;
        state.documentStatus = STATUSES.IDLE;
      })
      .addCase(getTemplatesApi.rejected, (state, action) => {
        state.documentStatus = STATUSES.ERROR;
      });
  },
});

export default getTemplateSlice.reducer;
